import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(items) {
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.items_cart_preview-new');
          itensCartPreview.innerHTML = '';

          items.forEach((item) => {
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

            let itemHTML = `
            <li class="cart-item">
              <figure>
                <img src="${item.image_medium}" alt="${item.name}">
              </figure>
              <div class="cart-item-content">
                <div class="cart-item-content-item">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                </div>
                <div class="cart-item-content-item">
                  ${variations}
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                </div>
              </div>
            </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          // Adiciona o event listener para os botões de deletar
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });
        }
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.cart_data.items) {
          updateCartPreview(data.cart_data.items);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
          let valid_status = [200, 201];
          if (valid_status.includes(xhr.status)) {
            const responseJson = xhr.responseJSON.cart_data.items;
            updateCartPreview(responseJson);
          }
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  const dataSrcset = elemento.getAttribute('data-srcset');
  if (dataSrc) {
    if (dataSrcset) {
      elemento.setAttribute('srcset', dataSrcset);
      elemento.removeAttribute('data-srcset');
    }
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

document.addEventListener("DOMContentLoaded", function() {
  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  if (tabAccordions) {
    tabAccordions.forEach(function (tabAccordion, index) {
      tabAccordion.addEventListener('click', function () {
          tabAccordions.forEach(function (tab) {
              tab.classList.remove('active');
          });

          contentAccordions.forEach(function (content) {
              content.classList.remove('active');
          });
          
          tabAccordion.classList.add('active');
          contentAccordions[index].classList.add('active');
      });
    });
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  // Ajustar tooltip de campanha no carrinho para mostrar nome completo
  function updateCampaignTooltips() {
    const campaignTooltips = document.querySelectorAll('.resume-ui__text[data-toggle="tooltip"][data-original-title]');
    campaignTooltips.forEach(tooltip => {
      const fullTitle = tooltip.getAttribute('data-original-title');
      if (fullTitle && tooltip.textContent !== fullTitle) {
        tooltip.textContent = fullTitle;
      }
    });
  }

  // Executar apenas se estiver na página do carrinho
  if (document.body.id === 'cart') {
    // Executar na primeira vez
    updateCampaignTooltips();

    // Observar mudanças no carrinho
    const cartElement = document.querySelector('#cart') || document.querySelector('.cart-resume-ui') || document.body;
    if (cartElement) {
      const cartObserver = new MutationObserver(() => {
        updateCampaignTooltips();
      });

      cartObserver.observe(cartElement, {
        childList: true,
        subtree: true
      });
    }
  }

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  // Adicionar mais eventos para melhor compatibilidade mobile
  $(window).on('scroll mousemove touchstart touchmove touchend', function () {
    loadWidgets();
  });
  
  // Adicionar evento específico para quando a página terminar de carregar
  $(document).ready(function() {
    loadWidgets();
  });

  function selectVariation(id, parent) {
    axios.get(`/api/front/product/${id}/get-linked-product/`).then(res => {
      const isProductItem = parent.classList.contains('product-item') ? true : false;
      const isModalPopup = parent.classList.contains('shoppub-fast-buy-popup') ? true : false;
      let productName = '';
      let radioVariations = '';
      let getBody = '';
      let dataIdAuto = '';
      // guarda a origem do radio antigo: é ela que define qual API de preço a plataforma chama ao trocar o tamanho
      const oldInput = parent.querySelector('.product-radio-variation input');
      const originLocation = oldInput?.getAttribute('data-origin-location') || (isProductItem || isModalPopup ? 'product_detail_list' : 'product_detail');
      //seleciona os elementos a serem alterados
      if (isProductItem) {
        productName = parent.querySelector('.product-item__content--figcaption h2');
        radioVariations = parent.querySelector(".product-item__content .product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = oldInput?.getAttribute('data-id-auto') || getBody.getAttribute('data-id-auto') || '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else if (isModalPopup) {
        productName = parent.querySelector('.product-item__content--figcaption h2');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = oldInput?.getAttribute('data-id-auto') || getBody.getAttribute('data-id-auto') || '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else {
        productName = parent.querySelector('#js-product_name__product_detail_');
        radioVariations = parent.querySelector(".product-detail__header--infoArea-kit .product-radio-variation");
        getBody = document.querySelector('body');
      }

      const linkName = "/produto/" + res.data.slug;

      //troca o nome do produto
      if (productName) {
        productName.innerHTML = res.data.name
        if (productName.tagName.toLowerCase() === 'a') {
          //substitui o link href da tag a (ainda experimental pois há variaveis, nao funciona sempre)
          productName.href = linkName;
        }
      }

      if (res.data.variations.length > 0) {
        $(radioVariations).html('');
        if (radioVariations && !isProductItem) {
          $(radioVariations).append('<p class="label_attributes"> escolha o tamanho </p>');
        }
        res.data.variations.forEach(function (variation) {
          const radioInput = $(`<input type="radio" name="product_item_variation__product_detail_${dataIdAuto}_${res.data.id}" id="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" value="${variation.id}" data-id-auto="${dataIdAuto}" data-variation-name="${variation.main_attribute.name}" data-origin-location="${originLocation}">`);

          const radioLabel = $(`<label for="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" class="label_radio ${!variation.available ? "out-of-stock" : ""} radio"><span>${variation.main_attribute.value}</span></label>`);

          radioLabel.on('click', function () {
            getBody.setAttribute('data-id-current', variation.id)
          });

          $(radioVariations).append(radioInput).append(radioLabel);
        })
      }

      if (isProductItem) {
        // can_sell real vem do swatch selecionado (data-not-cansell renderizado no template)
        const selectedColor = parent.querySelector('.product__colors-item.is-selected');
        const isAvailable = !(selectedColor && selectedColor.hasAttribute('data-not-cansell'));
        parent.classList.toggle('unavailable', !isAvailable);

        const buyButton = parent.querySelector('.product-item__options .column-buy');
        if (buyButton) {
          buyButton.classList.toggle('disabled', !isAvailable);
          buyButton.textContent = isAvailable ? 'adicionar ao carrinho' : 'ESGOTADO';
        }

        let figure = parent.querySelector('.product-item__content .product-item__content--figure');
        let price = parent.querySelector('.product-item__content .price');
  
        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}"><img class="block-img lazy-img" src="${res.data.images[0]}" alt="${res.data.name}"> <span class="product-item__content--figure-loading"></span><img src="${res.data.images[1]}" class="block-img lazy-img second" alt="${res.data.name}"/></a>`;
          }
        }

        const formatadorBRL = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        });

        // Usando novos parâmetros da API
        let a_vista_label = res.data.a_vista?.label || 'no pix';
        let preco_de = res.data.preco_de ? formatadorBRL.format(res.data.preco_de) : null;
        let preco_a_vista = res.data.a_vista?.valor ? formatadorBRL.format(res.data.a_vista.valor) : null;
        let parcelas_sem_juros_label = res.data.parcelamento?.parcelas_sem_juros_label || 'sem juros';
        let preco_parcelado_label = res.data.parcelamento?.preco_parcelado_label || 'no cartão';
        let priorizar_parcelas_sem_juros = res.data.parcelamento?.priorizar_parcelas_sem_juros || false;
        let max_parcelas = res.data.parcelamento?.max_parcelas || res.data.parcelamento?.max_parcelas_sem_juros;
        let max_parcelas_sem_juros = res.data.parcelamento?.max_parcelas_sem_juros;
        let valor_parcela_sem_juros = res.data.parcelamento?.valor_parcela_sem_juros ? formatadorBRL.format(res.data.parcelamento.valor_parcela_sem_juros) : null;
        let valor_parcela = res.data.parcelamento?.valor_parcela ? formatadorBRL.format(res.data.parcelamento.valor_parcela) : null;

        // Verifica se deve mostrar o preço de
        let mostrarPrecoDe = preco_de && res.data.a_vista?.habilitado && (res.data.preco_de != res.data.a_vista.valor);

        if (price) {
          if (priorizar_parcelas_sem_juros && max_parcelas_sem_juros) {
            price.innerHTML = `
              <div class="price">
                ${mostrarPrecoDe ? `<span class="price-of">${preco_de}</span>` : ''}
                ${preco_a_vista && res.data.a_vista?.habilitado ? `<span class="in-cash ${!mostrarPrecoDe ? 'not-price-of' : ''}">${preco_a_vista} ${a_vista_label}</span>` : ''}
                <span class="installment">ou ${max_parcelas_sem_juros}x de ${valor_parcela_sem_juros} ${parcelas_sem_juros_label}</span>
              </div>`;
          } else if (max_parcelas) {
            price.innerHTML = `
              <div class="price">
                ${mostrarPrecoDe ? `<span class="price-of">${preco_de}</span>` : ''}
                ${preco_a_vista && res.data.a_vista?.habilitado ? `<span class="in-cash ${!mostrarPrecoDe ? 'not-price-of' : ''}">${preco_a_vista} ${a_vista_label}</span>` : ''}
                <span class="installment">ou ${max_parcelas}x de ${valor_parcela} ${preco_parcelado_label}</span>
              </div>`;
          } else {
            price.innerHTML = `
              <div class="price">
                ${mostrarPrecoDe ? `<span class="price-of">${preco_de}</span>` : ''}
                ${preco_a_vista && res.data.a_vista?.habilitado ? `<span class="in-cash ${!mostrarPrecoDe ? 'not-price-of' : ''}">${preco_a_vista} ${a_vista_label}</span>` : ''}
              </div>`;
          }
        }

        const tags = parent.querySelector('.product-item__content .product-item__content--tag');
        tags.innerHTML = '';

        let tagLancamento = res.data.lancamento === true; 
        let tagOff = res.data.valor_desconto_percentual ? Math.ceil(res.data.valor_desconto_percentual) : 0;
        let tagCampaigns = res.data.campaigns || [];

        let tagCampaignsHtml = '';
        tagCampaigns.forEach(camp => {
          if (camp.nome_exibicao) {
            tagCampaignsHtml += `<span class="product-campaigns-tags__campaign" style='background-color: ${camp.nome_exibicao_vitrine_background_cor}; color: ${camp.nome_exibicao_vitrine_texto_cor}; border: 1px solid ${camp.nome_exibicao_vitrine_borda_cor};'>${camp.nome_exibicao}</span>`;
          }
        });

        if (tags) {
          let tagHtml = '';

          if (tagLancamento) {
            tagHtml += `
              <div class="product-item__content--tag-new">
                <span>NOVO</span>
              </div>
            `;
          }

          if (tagOff) {
            tagHtml += `
              <div class="product-item__content--tag-off">
                <span>${tagOff}% OFF</span>
              </div>
            `;
          }

          if (tagCampaignsHtml) {
            tagHtml += `
              <p class="product-campaigns-tags">
                ${tagCampaignsHtml}
              </p>
            `;
          }

          tagHtml += '';
          tags.innerHTML = tagHtml;
        }
      } else if (isModalPopup) {
        const figure = parent.querySelector('.product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else {
        const keepBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
        const keepBuyingImage = document.querySelector('.keeping-buying__figure--image');

        if (keepBuyingName && keepBuyingImage) {
          keepBuyingName.innerHTML = res.data.name;
          keepBuyingImage.setAttribute('src', `${res.data.images[0]}`);
        }

        $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
        $('.product-detail__header--photoArea-photo ul').html('');
        $('.product-detail__header--photoArea-thumbs-default ul').html('');
        if (res.data.images.length > 0) {
          res.data.images.forEach(function (image, index) {
            $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%;"><a href="${image}" data-fancybox="gallery3"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-photo ul').append(`<li class="sp-wrap" id="photo-${index}"><a href="${image}" data-fancybox="gallery1"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-thumbs-default ul').append(`<li class="sp-wrap" id="photo-${index}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></li>`);
          });
        }
      }

      if (getBody) {
        getBody.setAttribute('data-id', `${id}`);
        getBody.setAttribute('data-id-current', `${id}`);
      }
    }).catch(err => { console.log(err); });
  }


  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('product__colors-item') || event.target.classList.contains('product__colors-box')) {
      const isProductItem = event.target.closest('.product-item') ? true : false;
      const isModalPopup = event.target.closest('.shoppub-fast-buy-popup') ? true : false;
      if (isProductItem) {
        event.preventDefault();
        const productItem = event.target.closest('.product-item') ? event.target.closest('.product-item') : event.target.closest('.product-detail__header');
        const targetColor = event.target.classList.contains('product__colors-item') ? event.target : event.target.closest('.product__colors-item');
  
  
        const colorsContainer = productItem.querySelector('div.product__colors');
        const options = colorsContainer.querySelectorAll('.product__colors-item')
        options.forEach(option => {
          option.classList.remove('is-selected');
        });
  
        targetColor.classList.add('is-selected');
        const selected = targetColor.getAttribute('variation-id')
  
        selectVariation(selected, productItem);
      } else if (isModalPopup) {
        event.preventDefault();
        const productItem = event.target.closest('.shoppub-fast-buy-popup');
        const targetColor = event.target.classList.contains('product__colors-item') ? event.target : event.target.closest('.product__colors-item');
        const selected = targetColor.getAttribute('variation-id')
        selectVariation(selected, productItem);
      }
    }
  });
  
});